import autosize from 'autosize';

export default function() {
    // add active class
    const handleFocus = e => {
        const target = e.target;
        target.parentNode.classList.add('active');
    };

    // remove active class
    const handleBlur = e => {
        const target = e.target;
        if (!target.value) {
            target.parentNode.classList.remove('active');
        }
    };

    // register events
    const bindEvents = element => {
        const floatField = element.querySelector('.form-control');
        if (floatField) {
            floatField.addEventListener('focus', handleFocus);
            floatField.addEventListener('blur', handleBlur);
        }
    };

    // get DOM elements
    const floatContainers = document.querySelectorAll(
        '.c-form__floatinglabels .form-group.shortanswer, .c-form__floatinglabels .form-group.longanswer, .c-form__floatinglabels .form-group.password, .c-form__floatinglabels .form-group.dropdown, .c-form__floatinglabels .form-group.date, .c-form__floatinglabels .form-group.fileupload'
    );
    for (var i = 0, len = floatContainers.length; i < len; i++) {
        const formControl = floatContainers[i].querySelector('.form-control');
        if (formControl && formControl.value) {
            floatContainers[i].classList.add('active');
        }

        bindEvents(floatContainers[i]);
    }

    autosize(document.querySelectorAll('textarea'));
}
